/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Badge_PopularInputs */

const tr_landing_pricing_badge_popular = /** @type {(inputs: Landing_Pricing_Badge_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Popüler`)
};

const en_landing_pricing_badge_popular = /** @type {(inputs: Landing_Pricing_Badge_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most Popular`)
};

const de_landing_pricing_badge_popular = /** @type {(inputs: Landing_Pricing_Badge_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am beliebtesten`)
};

const ru_landing_pricing_badge_popular = /** @type {(inputs: Landing_Pricing_Badge_PopularInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самый популярный`)
};

/**
* | output |
* | --- |
* | "Most Popular" |
*
* @param {Landing_Pricing_Badge_PopularInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricing_badge_popular = /** @type {((inputs?: Landing_Pricing_Badge_PopularInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Badge_PopularInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_badge_popular(inputs)
	if (locale === "de") return de_landing_pricing_badge_popular(inputs)
	if (locale === "ru") return ru_landing_pricing_badge_popular(inputs)
	return tr_landing_pricing_badge_popular(inputs)
});